import { render, staticRenderFns } from "./SignUpFranchiseStepOnePending.vue?vue&type=template&id=a563e6ea&scoped=true&"
import script from "./SignUpFranchiseStepOnePending.vue?vue&type=script&lang=js&"
export * from "./SignUpFranchiseStepOnePending.vue?vue&type=script&lang=js&"
import style0 from "./SignUpFranchiseStepOnePending.vue?vue&type=style&index=0&id=a563e6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a563e6ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoWithTradeMark: require('/home/circleci/repo/components/LogoWithTradeMark.vue').default,VButton: require('/home/circleci/repo/components/VButton.vue').default})
